const INVITE_STATUS = {
  expired: 'expired',
  refused: 'refused',
  pending: 'pending',
  canceled: 'canceled'
}

export const inviteIsExpired = statusKey => {
  return INVITE_STATUS.expired === statusKey.toLowerCase()
}

export const inviteIsRefused = statusKey => {
  return INVITE_STATUS.refused === statusKey.toLowerCase()
}

export const inviteIsPending = statusKey => {
  return INVITE_STATUS.pending === statusKey.toLowerCase()
}

export const inviteIsCanceled = statusKey => {
  return INVITE_STATUS.canceled === statusKey.toLowerCase()
}
